/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommunityControllerDtoPostAccountSearchRequest model module.
 * @module model/CommunityControllerDtoPostAccountSearchRequest
 * @version 1.0
 */
class CommunityControllerDtoPostAccountSearchRequest {
    /**
     * Constructs a new <code>CommunityControllerDtoPostAccountSearchRequest</code>.
     * @alias module:model/CommunityControllerDtoPostAccountSearchRequest
     */
    constructor() { 
        
        CommunityControllerDtoPostAccountSearchRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CommunityControllerDtoPostAccountSearchRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommunityControllerDtoPostAccountSearchRequest} obj Optional instance to populate.
     * @return {module:model/CommunityControllerDtoPostAccountSearchRequest} The populated <code>CommunityControllerDtoPostAccountSearchRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommunityControllerDtoPostAccountSearchRequest();

            if (data.hasOwnProperty('searchString')) {
                obj['searchString'] = ApiClient.convertToType(data['searchString'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommunityControllerDtoPostAccountSearchRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommunityControllerDtoPostAccountSearchRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['searchString'] && !(typeof data['searchString'] === 'string' || data['searchString'] instanceof String)) {
            throw new Error("Expected the field `searchString` to be a primitive type in the JSON string but got " + data['searchString']);
        }

        return true;
    }


}



/**
 * @member {String} searchString
 */
CommunityControllerDtoPostAccountSearchRequest.prototype['searchString'] = undefined;






export default CommunityControllerDtoPostAccountSearchRequest;

